// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.82936 16.1426L7.3164 17.238C7.46118 17.564 7.69747 17.8411 7.99659 18.0355C8.29571 18.23 8.64483 18.3334 9.00159 18.3334C9.35835 18.3334 9.70746 18.23 10.0066 18.0355C10.3057 17.8411 10.542 17.564 10.6868 17.238L11.1738 16.1426C11.3472 15.7539 11.6388 15.4299 12.0071 15.2167C12.3778 15.0029 12.8066 14.9118 13.2321 14.9565L14.4238 15.0834C14.7785 15.1209 15.1365 15.0547 15.4544 14.8928C15.7722 14.7309 16.0363 14.4803 16.2145 14.1713C16.393 13.8625 16.4781 13.5086 16.4593 13.1524C16.4406 12.7963 16.3189 12.4532 16.109 12.1648L15.4034 11.1954C15.1522 10.8476 15.018 10.429 15.0201 10C15.02 9.57218 15.1555 9.15531 15.4071 8.80928L16.1127 7.83984C16.3226 7.55148 16.4443 7.20841 16.463 6.85225C16.4818 6.49608 16.3967 6.14214 16.2183 5.83335C16.04 5.52438 15.7759 5.27376 15.4581 5.11188C15.1402 4.94999 14.7822 4.8838 14.4275 4.92132L13.2358 5.04817C12.8103 5.09286 12.3815 5.00179 12.0108 4.78798C11.6418 4.57356 11.3501 4.24782 11.1775 3.85743L10.6868 2.76206C10.542 2.436 10.3057 2.15895 10.0066 1.96452C9.70746 1.77009 9.35835 1.66663 9.00159 1.66669C8.64483 1.66663 8.29571 1.77009 7.99659 1.96452C7.69747 2.15895 7.46118 2.436 7.3164 2.76206L6.82936 3.85743C6.6568 4.24782 6.36509 4.57356 5.99603 4.78798C5.62538 5.00179 5.19659 5.09286 4.77103 5.04817L3.57566 4.92132C3.22094 4.8838 2.86294 4.94999 2.54509 5.11188C2.22724 5.27376 1.96317 5.52438 1.78492 5.83335C1.60644 6.14214 1.52141 6.49608 1.54014 6.85225C1.55888 7.20841 1.68058 7.55148 1.89048 7.83984L2.59603 8.80928C2.84765 9.15531 2.98315 9.57218 2.98307 10C2.98315 10.4279 2.84765 10.8447 2.59603 11.1908L1.89048 12.1602C1.68058 12.4486 1.55888 12.7916 1.54014 13.1478C1.52141 13.504 1.60644 13.8579 1.78492 14.1667C1.96335 14.4755 2.22744 14.726 2.54525 14.8878C2.86306 15.0497 3.22096 15.116 3.57566 15.0787L4.76733 14.9519C5.19289 14.9072 5.62167 14.9983 5.99233 15.2121C6.36277 15.4259 6.65583 15.7517 6.82936 16.1426Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.0001 12.5C10.3808 12.5 11.5001 11.3807 11.5001 10C11.5001 8.61931 10.3808 7.50002 9.0001 7.50002C7.61939 7.50002 6.5001 8.61931 6.5001 10C6.5001 11.3807 7.61939 12.5 9.0001 12.5Z"
    />
  </svg>
);
const IconSettings = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconSettings;
